import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Alert, Button } from 'reactstrap';
import { contactActions } from '../../../core/contact/actions';
import { ContactForm } from '../../components/contact/ContactForm';
import { connect } from 'react-redux';
import LoadingIndicator from '../../components/loading-indicator/loading-indicator';
import { WelcomeMessage } from '../auth/WelcomeMessage';

const emailRegex = RegExp(
    /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
);

const ContactUs = ({ contact, sendContact, resetContact, user, systemCheck }) => {
    const navigate = useNavigate();
    const [formErrors, setformErrors] = useState({
        name: '',
        phone: '',
        email: '',
        comments: ''
    });
    const [inputValues, setInputValues] = useState({
        name: '',
        phone: '',
        email: '',
        comments: ''
    })

    useEffect(() => {
        return () => {
            resetContact();
        }
    }, [])

    const handleInputChange = async ({ target }) => {
        const { name, value } = target;

        switch (name) {
            case "name":
                formErrors.name =
                    value.length < 3 ? "Minimum 3 characters required" : "";
                break;
            case "phone":
                formErrors.phone =
                    value.length < 3 ? "Minimum 3 characters required" : "";
                break;
            case "email":
                formErrors.email = emailRegex.test(value)
                    ? ""
                    : "Invalid email address";
                break;
            case "comments":
                formErrors.comments =
                    value.length < 1 ? "Minimum 1 characters required" : "";
                break;
            default:
                break;
        }

        setInputValues({
            ...inputValues,
            [name]: value
        });
    }

    const onSubmitRegister = async (e) => {
        e.preventDefault();
        if (formValid()) {
            sendContact(inputValues)
        }
    }

    const formValid = () => {
        let valid = true;
        let keysNotRequired = ['phone']

        // validate form errors being empty
        Object.values(formErrors).forEach(val => {
            val.length > 0 && (valid = false);
        });

        // validate the form was filled out
        Object.keys(inputValues).forEach((key) => {
            if (!keysNotRequired.includes(key)) {
                inputValues[key] == '' && (valid = false);
            }
        })

        return valid;
    };

    return (
        <Container fluid="xl" className='minvh-100 px-0 px-md-3'>
            <div className="d-md-flex align-items-md-stretch justify-content-md-center minvh-100">
                <WelcomeMessage displayClass={'d-none d-md-block'}/>
                {!systemCheck.isPending && !user.isPending && 
                <div className="col-login p-md-4 align-self-center">
                    <div className='bg-white p-4 col-login-form d-flex flex-column h-100'>
                        <div className="content-login mb-auto">
                            <div className='mb-3 d-flex align-items-center'>
                                <Button color='link' className="text-body p-0 mr-3 mb-1" onClick={() => navigate(-1)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="24" height="20" viewBox="0 0 24 20">
                                        <path d="M24,10c0,0.3-0.1,0.5-0.3,0.7C23.5,10.9,23.3,11,23,11H3.4l7.3,7.3c0.1,0.1,0.2,0.2,0.2,0.3
                                                C11,18.7,11,18.9,11,19c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2C10.3,20,10.1,20,10,20
                                                c-0.1,0-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.1-0.3-0.2l-9-9c-0.1-0.1-0.2-0.2-0.2-0.3C0,10.3,0,10.1,0,10c0-0.1,0-0.3,0.1-0.4
                                                c0.1-0.1,0.1-0.2,0.2-0.3l9-9C9.5,0.1,9.7,0,10,0c0.3,0,0.5,0.1,0.7,0.3C10.9,0.5,11,0.7,11,1c0,0.3-0.1,0.5-0.3,0.7L3.4,9H23
                                                c0.3,0,0.5,0.1,0.7,0.3C23.9,9.5,24,9.7,24,10z"/>
                                    </svg>
                                </Button>
                                <h1 className='libre-caslon-text-regular h3-md h4 mb-0'>Contact us</h1>
                            </div>
                            {!contact.success ?
                                <ContactForm
                                    formErrors={formErrors}
                                    handleInputChange={handleInputChange}
                                    inputValues={inputValues}
                                    onSubmitRegister={onSubmitRegister}
                                    formValid={formValid}
                                />
                                :
                                <Alert color="info">Your message has been sent.</Alert>
                            }
                        </div>
                    </div>
                    
                </div>
                }
            </div>
            {(contact.isPending || systemCheck.isPending || user.isPending) && <LoadingIndicator />}
        </Container>
    )
}
//=====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = (state, props) => {
    const { contact, user, systemCheck } = state;
    return {
        contact,
        user,
        systemCheck
    };
};

const mapDispatchToProps = {
    sendContact: contactActions.loadContact,
    resetContact: contactActions.resetContact
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ContactUs);
